import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import { Box, Button, TextField, Typography } from '@mui/material';
import Logo from '../../assets/logo_pf_auditores.png';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { email, senha } = event.target.elements;

    try {
      await login(email.value, senha.value);
    } catch (error) {
      console.error('Erro durante o login:', error);
      setError('Ocorreu um erro durante o login. Por favor, tente novamente mais tarde.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <img src={Logo} alt="Logo" style={{ width: 150 }} />
      </Box>
      <Box
        sx={{
          width: '100%',
          maxWidth: 400,
          p: 3,
          backgroundColor: '#fff',
          borderRadius: 2,
          border: '1px solid #000000',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        {error && <Typography color="error" mb={2}>{error}</Typography>}
        <form onSubmit={handleSubmit}>
          <TextField 
            id="email" 
            name="email" 
            label="Email" 
            type="email" 
            fullWidth 
            required 
            sx={{ mb: 2, backgroundColor: 'white' }} 
          />
          <TextField 
            id="senha" 
            name="senha" 
            label="Senha" 
            type="password" 
            fullWidth 
            required 
            sx={{ mb: 2, backgroundColor: 'white' }} 
          />
          <Button type="submit" variant="contained" fullWidth>Login</Button>
        </form>
      </Box>
    </Box>
  );
};

export default Login;
